export default "__VITE_ASSET__foyuxZAT__"